import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorType } from '@enum/error.enum';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  errorMessage: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.setErrorMessage();
  }

  private setErrorMessage(): void {
    const errorType: string = this.route.snapshot.paramMap.get('errorType');

    switch (errorType) {
      case ErrorType.CANNOTDOWNLOAD:
        this.errorMessage = 'errors.cannotDownload';
        break;
      case ErrorType.LINKEXPIRED:
        this.errorMessage = 'errors.linkExpired';
        break;
      case ErrorType.NOTFOUND:
        this.errorMessage = 'errors.notFound';
        break;
      default:
        this.errorMessage = 'errors.unexpected';
    }
  }
}
